<template>
    <aside @click.stop class="sidebar sidebar--tenant">
        <nav v-for="tenant in tenants" :key="tenant.id" class="lc-tenant-navigation tenant-navigation">
            <a :href="tenant.url" class="tenant-navigation__item" :class="{'active' : currentTenant.id === tenant.id }">
                <span>{{ tenant.initials }}</span>
            </a>
        </nav>
    </aside>
</template>

<script>
import currentTenantAware from '../../mixins/currentTenantAware'

export default {
    name: 'Tenants',

    mixins: [currentTenantAware],

    props: {
        tenants: {
            type: Array,
            required: true
        }
    }
}
</script>
